export default "__VITE_PUBLIC_ASSET__657ba927__"